module.exports = __webpack_public_path__ + "img/woodpacking.93511508.svg";